// Win animation: confetti + coin fountain (canvas #fx)
export function createConfetti(canvas, stage) {
  const g = canvas.getContext('2d');
  let parts = [], running = false, raf = 0;

  function resize() {
    const d = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = stage.clientWidth * d;
    canvas.height = stage.clientHeight * d;
    canvas.style.width = stage.clientWidth + 'px';
    canvas.style.height = stage.clientHeight + 'px';
  }

  function celebrate(big) {
    const W = canvas.width, H = canvas.height, u = H / 600;
    const pal = ['#ffd21f', '#ff4d4d', '#38d96b', '#ffffff', '#4db8ff', '#ff9d00'];
    for (let i = 0; i < (big ? 240 : 130); i++) {
      parts.push({ k: 'c', x: Math.random() * W, y: -Math.random() * H * 0.5, vx: (Math.random() - 0.5) * 2 * u, vy: (2 + Math.random() * 4) * u,
        w: (7 + Math.random() * 7) * u, h: (4 + Math.random() * 5) * u, r: Math.random() * 6, vr: (Math.random() - 0.5) * 0.3, col: pal[i % pal.length], ph: Math.random() * 6 });
    }
    for (let i = 0; i < (big ? 34 : 18); i++) {
      parts.push({ k: 'o', x: W * (0.35 + Math.random() * 0.3), y: H * 0.9, vx: (Math.random() - 0.5) * 13 * u, vy: -(15 + Math.random() * 11) * u,
        g: 0.38 * u, rad: (11 + Math.random() * 7) * u, ph: Math.random() * 6, vp: 0.2 + Math.random() * 0.2 });
    }
    if (!running) { running = true; raf = requestAnimationFrame(loop); }
  }

  function loop() {
    g.clearRect(0, 0, canvas.width, canvas.height);
    parts = parts.filter((p) => p.y < canvas.height + 60);
    for (const p of parts) {
      if (p.k === 'c') {
        p.x += p.vx + Math.sin((p.ph += 0.06)) * 1.2; p.y += p.vy; p.r += p.vr;
        g.save(); g.translate(p.x, p.y); g.rotate(p.r); g.scale(1, Math.cos(p.ph * 2));
        g.fillStyle = p.col; g.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); g.restore();
      } else {
        p.vy += p.g; p.x += p.vx; p.y += p.vy; p.ph += p.vp;
        g.save(); g.translate(p.x, p.y); g.scale(Math.abs(Math.cos(p.ph)) * 0.85 + 0.15, 1);
        const gr = g.createRadialGradient(-p.rad * 0.3, -p.rad * 0.3, 1, 0, 0, p.rad);
        gr.addColorStop(0, '#fff3a0'); gr.addColorStop(1, '#e0a000');
        g.beginPath(); g.arc(0, 0, p.rad, 0, 7); g.fillStyle = gr; g.fill();
        g.lineWidth = p.rad * 0.15; g.strokeStyle = '#8a5a00'; g.stroke();
        g.beginPath(); g.arc(0, 0, p.rad * 0.62, 0, 7); g.stroke(); g.restore();
      }
    }
    if (parts.length) raf = requestAnimationFrame(loop);
    else { running = false; g.clearRect(0, 0, canvas.width, canvas.height); }
  }

  function destroy() { cancelAnimationFrame(raf); parts = []; running = false; }

  resize();
  return { celebrate, resize, destroy };
}
